import React, { useEffect, useState } from 'react';
import { Row, Col, Button, Form } from 'react-bootstrap';
import {useNavigate} from 'react-router-dom';
import './../../../translations/i18n';
import { useTranslation } from 'react-i18next';
import Content from './../../../data/content.json';
//redux
import { useSelector } from 'react-redux';
import { loggedinUserInfo } from '../../../store/slices/UserSlice';

import loadable from '@loadable/component';
const RequestServiceModal = loadable(() => import('./RequestServiceModal'));
// import RequestServiceModal from './RequestServiceModal';
const HomePricingPlan = (props) => {
  const { t } = useTranslation();
  const { recaptchValidate } = props;
  const language = useSelector((state) => state.user.language);
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
	const user_info = useSelector(loggedinUserInfo); //for redux EX:- user_info: loggedinUserData
  const navigate = useNavigate();
  const [pricePlanChecked, setPricePlanChecked] = useState(false);
  const [priceType , setPriceType] = useState('bookkeeping');
  const [serviceType, setServiceType] = useState('');
  
  const pricePlanChange = (e) => {
    setPricePlanChecked(e.target.checked);
    if(e.target.checked){
      setPriceType('zakat');
    }else{
      setPriceType('bookkeeping');
    }
  }

  const [priceDurationChecked, setpriceDurationChecked] = useState(true);
  const priceDurationChange = (e) => {
    setpriceDurationChecked(!priceDurationChecked);
  }
  useEffect(() => {
    setpriceDurationChecked(true);
    if('bookkeeping' === priceType){
      setpriceDurationChecked(false);      
    }
  },[priceType]);


  const contactClickHandaler = (index)=>{
    if(index > 1){
      //show request service popup
      setShow(true);
      setServiceType('bookkeeping' === priceType? 'Accounting' : 'Zakat & Tax');
    }else{
      let url = `/${language}/sign-up`;
      if(isLoggedIn){
        if( 'C' === user_info?.user_type ){	
          url =  `/${language}/services`;	
        }else{
          url = `/${language}/admin/dashboard`;
        }
      }    
      navigate(url);
    }
  }
  /**  for request service modal */
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);  
  const handleClose = () =>setShow(false);
  /**  end request service modal */
  
  return (
    <>
    <section className="mt-2 mb-3 mt-md-5 mb-md-5 text-center">
      <div className="can-toggle inblk">
        <input id="a" type="checkbox" onChange={e => pricePlanChange(e)}/>
        <label htmlFor="a">
          <div className="can-toggle__switch" data-checked={t('Zakat and Tax')} data-unchecked={t('Accounting')}></div>
        </label>
      </div>
    </section>
      <div className="mb-3 mb-md-5" style={{height:"32px"}}>
      {priceType === 'bookkeeping' &&       
          <div className="text-center prcmntchk">
            <section className="inblk">
              <label>
                <span className="inblk">{t('Monthly')}</span>
                <Form.Check inline type="switch" onChange={e => priceDurationChange(e)}/>
                <span className="inblk">{t('Annually')}</span>
              </label>
            </section>
          </div>
      }</div>
      <section className={`prctgl ${pricePlanChecked?'bookkeeping':'zakat'}`}>
        <div className={priceDurationChecked?'anually':'monthly'}>
          <article className={`${pricePlanChecked ? 'bkkpBX' : 'zakatBX'} ${priceDurationChecked ? 'yearly':'mnthly'}`}>
            <Row className="prcbxpnl" xs={1} sm={2} md={3}>
              {Content?.Pricing?.price && Content?.Pricing?.price?.[priceType].map((pri, index)=>(
                <Col key={index}>
                  <div className="prcbx d-flex flex-column">
                    <section className="top">
                      <h2>{pri?.title?.[language]}</h2>
                      <div className="tg">{pri?.des?.[language]}</div>
                      <div className="prc">{index <= 1 ? 'SAR' : ''}<span>{t(priceDurationChecked ? pri?.price_per_year: pri?.price_per_month)}</span><sup>*</sup></div>
                      <p>{t(priceDurationChecked ? pri?.price_per_year_tag?.[language]: pri?.price_per_month_tag?.[language])}&nbsp;</p>
                      <article>
                        <ul>
                          {pri?.feature && pri?.feature.map((fea, ind)=>(
                            <li key={ind}>{fea?.[language]}</li>
                          ))}
                        </ul>
                      </article>
                    </section>
                    <section className="btm">
                      <Button variant="thm2 text-capitalize nofcs" size="lg" onClick={()=>contactClickHandaler(index)} aria-label="Get started">{index <= 1 ? t( 'Get started') : t('Contact us')}</Button>
                    </section>
                  </div>
                </Col>
              ))}
            </Row>
          </article>
          <div className="mt-3"><sup style={{color:"#f36565"}}>*</sup> {t('The price excluding 15% VAT')}</div>
        </div>
      </section>
      {show && <RequestServiceModal show={show} onClose={handleClose} serviceType={serviceType} recaptchValidate={recaptchValidate} /> }
      
    </>
  );
}

export default HomePricingPlan;